import {v4 as uuidv4} from "uuid"

export type FlowType = {
    id?: string,
    embedding?: any,
    name: string,
    description?: string, 
    status: "draft" | "published" | "archived" | "hidden",
    type: string,
    form_id?:string,
    actions: ActionType[],
    connections: Object[]
}

export type ActionType = {
    id: string,
    type: string,
    action: Object
}


const FlowDefault:FlowType = {
    name: "",
    status: "draft",
    description: "",
    type: "default",
    actions: [],
    connections: []
}

export function newFlow(name: string, type: string, trigger: string, description:string = "" ):FlowType {
    return {...FlowDefault, name: name, type: type || "default", description:description, actions: [
        {
            id: uuidv4(),
            type: "trigger",
            action: {
                trigger: trigger
            }
        }
    ]};
}